import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: "AIzaSyCWvxjL_mBAM7ZuLeJDPaCrXqcrAU8QPD8",
  authDomain: "ukba-kasa-34bd3.firebaseapp.com",
  projectId: "ukba-kasa-34bd3",
  storageBucket: "ukba-kasa-34bd3.firebasestorage.app",
  messagingSenderId: "569416488871",
  appId: "1:569416488871:web:784552acf2e4ed6701c882",
  measurementId: "G-CNSBWSMMBS"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

const appCheckSiteKey = String(process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY || '').trim();
if (typeof window !== 'undefined' && appCheckSiteKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true
  });
}